import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './user-body-input_types.2';

export function setUserAccountBody(variable: types.SetUserAccountBodyVariables, options?: GqlRequestOptions) {
  const query = 'mutation SetUserAccountBody($input: SetUserAccountBodyInput!) { result: setUserAccountBody(input: $input) }';
  return gql_request<types.SetUserAccountBody, types.SetUserAccountBodyVariables>('SetUserAccountBody', query, variable, { use_consumer: true, ...options });
}

